module.exports = __webpack_public_path__ + "media/kr_web_10w.538dc746.mp4";